import React from "react";
//#region types
import { LocalizationHelperInstance } from "utils/helpers";
import { CommonConstants, IconDefinitionConstants } from "utils/constants";
import { DialogEnums } from "models/enums";
import { DialogProps } from "models/propTypes/dialogPropTypes";
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
import { TranslationKeys } from "translations";
//#endregion
//#region components
import { RevenueReportingCreateFormContainer } from "components/revenueReporting";
//#endregion

function useCreateRevenueReportingDialog() {
  return (
    templates: WintSuperkollAPIModel.RevenueReportingTemplate[],
    onCreateSuccess?: () => void,
    preselectedTemplateId?: string,
    periodLastDay?: Date
  ): DialogProps => ({
    id: CommonConstants.RevenueReportingCreateDialogId,
    isOpen: false,
    title: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.RevenueReporting.SubmitRevenueReport),
    titleIcon: IconDefinitionConstants.WCalculator,
    actions: [
      {
        text: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.RevenueReporting.Submit),
        successMessage: TranslationKeys.RevenueReporting.CreatedRevenueReport,
      },
    ],
    dialogType: DialogEnums.DialogType.Content,
    children: (
      <RevenueReportingCreateFormContainer
        templates={templates}
        preselectedTemplateId={preselectedTemplateId}
        periodLastDay={periodLastDay}
      />
    ),
    maxWidth: "md",
    onSubmit: onCreateSuccess,
  });
}

export default useCreateRevenueReportingDialog;
